export const BOOT_RELOAD_GUARD_KEY = "remi:reloadedAfterBootFailure";
export const VERSION_RELOAD_GUARD_KEY = "remi:reloadedForApiVersion";

const MODULE_LOAD_FAILURE_PATTERN = /module factory is not available|ChunkLoadError|Failed to load chunk/;

export function getErrorText(error: unknown): string {
  if (error instanceof Error) {
    return `${error.name}: ${error.message}`;
  }
  return typeof error === "string" ? error : "";
}

function isNextBooted(nextGlobal: unknown): boolean {
  return typeof nextGlobal === "object" && nextGlobal !== null && Boolean(Reflect.get(nextGlobal, "router"));
}

export function shouldReloadAfterBootFailure({ error, nextGlobal }: { error: unknown; nextGlobal: unknown }): boolean {
  return !isNextBooted(nextGlobal) && MODULE_LOAD_FAILURE_PATTERN.test(getErrorText(error));
}

// Returns false when this tab already reloaded for `value`, or when sessionStorage is unusable: a reload we
// cannot record could repeat forever.
export function claimReloadGuard(key: string, value: string): boolean {
  try {
    if (sessionStorage.getItem(key) === value) {
      return false;
    }
    sessionStorage.setItem(key, value);
    return sessionStorage.getItem(key) === value;
  } catch {
    return false;
  }
}
